import { useEffect, useState } from 'react';

const useMediaQuery = (query: string) => {
  if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') {
    return false;
  }

  const mediaQuery = window.matchMedia(query);
  const [isMatch, setIsMatch] = useState(!!mediaQuery.matches);

  useEffect(() => {
    const handler = () => setIsMatch(!!mediaQuery.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return isMatch;
};

export default useMediaQuery;
